import { Month, MONTHS } from 'util/types/months';
import * as z from 'zod';
import { ErrorMessages } from '../error-messages';

export const updateGraduationDateFormSchema = z.object({
  month: z.nativeEnum(MONTHS as Record<number, Month>),
  year: z
    .number()
    .min(1900, ErrorMessages.GradYear.INVALID)
    .max(2100, ErrorMessages.GradYear.INVALID)
    .optional()
    .refine(x => !!x, { message: ErrorMessages.GradYear.INVALID }),
});

export type UpdateGraduationDateForm = Required<
  z.TypeOf<typeof updateGraduationDateFormSchema>
>;

export const updateGraduationYearFormSchema = z.object({
  year: z
    .number()
    .min(2023, ErrorMessages.GradYear.INVALID)
    .max(2035, ErrorMessages.GradYear.INVALID)
    .optional()
    .refine(x => !!x, { message: ErrorMessages.GradYear.INVALID }),
});

export type UpdateGraduationYearForm = Required<
  z.TypeOf<typeof updateGraduationYearFormSchema>
>;
